/** 来源：foodbuy/market EmptyState；保留标题、说明、操作的公共子集，不引图标依赖。 */
import type { ComponentType, ReactNode } from 'react'

type EmptyIcon = ComponentType<{ size?: number; 'aria-hidden'?: boolean | 'true' | 'false' }>

export type EmptyStateProps = {
  title?: string
  description?: string
  action?: ReactNode
  symbol?: ReactNode
  icon?: EmptyIcon
  compact?: boolean
  className?: string
}

export function EmptyState({
  title = '暂无数据',
  description,
  action,
  symbol = '∅',
  icon: Icon,
  compact = false,
  className = ''
}: EmptyStateProps) {
  return (
    <div className={`grid place-items-center content-center px-5 text-center ${compact ? 'py-8' : 'py-10'} ${className}`.trim()}>
      <span className="grid h-10 w-10 place-items-center rounded-[var(--radius-md)] bg-[var(--color-soft)] text-[var(--color-faint)]" aria-hidden="true">{Icon ? <Icon size={20} aria-hidden="true" /> : symbol}</span>
      <h3 className="mt-2.5 text-sm font-semibold text-[var(--color-ink)]">{title}</h3>
      {description ? <p className={`mt-1 text-xs text-[var(--color-muted)] ${action ? 'mb-4' : 'mb-0'}`}>{description}</p> : null}
      {action}
    </div>
  )
}
